import { IModuleTranslation } from '@larscom/ngx-translate-module-loader';

const baseTranslateUrl = './assets/i18n/questionnaire';

export const questionnaire: Array<IModuleTranslation> = [
  {
    baseTranslateUrl,
    moduleName: 'questionnaire-introduction',
    pathTemplate: '{baseTranslateUrl}/introduction/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: 'questionnaire-general',
    pathTemplate: '{baseTranslateUrl}/general/{language}'
  }
];
